module.exports = __webpack_public_path__ + "static/Number-3-7dff7a9405454160972fbceea8b3e1db.png";